import { MealBackgroundStyle } from '@tovala/component-library'

/*
 * The component library uses these same text colors on meal cards, but it only
 * exports the type and not the values. Headings and other text that sit next to
 * those cards have to match them, so we keep a copy here.
 */
export const HEADING_CLASS_MAP: { [key in MealBackgroundStyle]: string } = {
  dark: 'text-white',
  light: '',
  tinted: '',
}

export const SUBHEADING_CLASS_MAP: { [key in MealBackgroundStyle]: string } = {
  dark: 'text-grey-1',
  light: 'text-grey-9',
  tinted: 'text-grey-9',
}
